// extracted by mini-css-extract-plugin
module.exports = {"tabList":"PagePresentationWithTabs_tabList__g62tr"};